import type { ReactNode } from 'react'
import { cn } from '../../lib/cn'

/** Never "no data" without a next action. */
export function EmptyState({ icon, title, body, action, className }: { icon?: ReactNode; title: string; body?: string; action?: ReactNode; className?: string }) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 rounded-xl border bg-muted/30 px-6 py-12 text-center', className)}>
      {icon ? <div className="text-muted-foreground/40 [&_svg]:size-8">{icon}</div> : null}
      <div className="space-y-1">
        <p className="text-base font-semibold">{title}</p>
        {body ? <p className="mx-auto max-w-md text-sm text-muted-foreground">{body}</p> : null}
      </div>
      {action ? <div className="mt-2 flex flex-wrap items-center justify-center gap-2">{action}</div> : null}
    </div>
  )
}
